export const betaEnvConfig = {
  DISABLED_CONSOLE_MSG: false,
  YOLO_BASE_URL: 'https://www.yolorekt.finance',
  BASE_BRANCH: 'beta',

  // CRYPTO
  APPROVED_CHAINS_IDS: [137],

  //BACKEND CONNECTION
  YOLO_API_BASE_URL: 'https://temp-api.yolorekt.finance',
  BACKEND_SOCKET_URL: 'https://beta-old.yolorekt.finance',
  GATEWAY_SOCKET_URL: 'https://beta-old.yolorekt.finance',
  CONTRACTS_VERSION: '31',
}
